module.exports = __webpack_public_path__ + "img/calendar2-date-fill.3153f823.svg";